import React from "react";
import { Helmet } from "react-helmet";

const title = `ClipThoughts | Podcast`;

const url = "https://clipthoughts.com/podcasts"

const keywords = `Podcast annotation tool, annotate podcasts, podcast bookmarking app, podcast note-taking,
Apple/Spotify podcast annotation, bookmark apple podcasts, Apple podcast transcript generator,
clip annotation tools, bookmark podcast clips, podcast note-taking,
annotate podcast content, podcast transcript generator, annotate transcripts,
how to annotate apple podcasts, how to annotate spotify podcasts, best way to take notes on a apple podcast,
transcribe a podcast, summarize a podcast, best way to take notes on a podcast`

const description = "ClipThoughts Podcast is a comprehensive platform for making notes, annotations, and bookmarks on podcasts, enhancing your learning and content management experience."

const image = "https://clipthoughts.com/image.jpg"

const PodcastHelmet = () => {
    return (
        <>
            <Helmet>
                <title> {title} </title>
                <link rel="canonical" href={url} />
                <meta name="description" content={description} />
                <meta name="keywords" content={keywords}/> 
                <meta name="author" content="ClipThoughts Team" />
                <meta name="copyright" content="2023 ClipThoughts" />
                <meta name="robots" content="index, follow" />
                <meta name="googlebot" content="index, follow" />
                <meta name="bingbot" content="index, follow" />
                <meta name="geo.region" content="US" />
                <meta name="geo.placename" content="United States" />
                <meta name="og:title" content={title} />
                <meta name="og:description" content={description} />
                <meta name="og:image" content={image} />
                <meta name="og:url" content={url} />
                <meta name="og:type" content="website" />
                <meta name="og:site_name" content="ClipThoughts" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@clipthoughts" />
                <meta name="twitter:title" content={title} />
                <meta name="twitter:description" content={description} />
                <meta name="twitter:image" content={image} />
                <meta name="twitter:creator" content="@clipthoughts" />
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "WebPage",
                        "name": title,
                        "description": description,
                        "url": url,
                        "image": image,
                        "author": {
                            "@type": "Organization",
                            "name": "ClipThoughts"
                        }
                    })}
                </script>
            </Helmet>
        </>
    );
}

export default PodcastHelmet;